var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHostTenantShell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 4H16V6H18V4Z",
    fill: "#526069"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8H16V10H18V8Z",
    fill: "#526069"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12H16V14H18V12Z",
    fill: "#526069"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8V18H6V13H8V18H14V8L7 3L0 8ZM12 16H10V11H4V16H2V9L7 5.5L12 9V16Z",
    fill: "#526069"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 0V1.97L11 3.4V2H20V16H16V18H22V0H9Z",
    fill: "#526069"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHostTenantShell);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAyMiAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE4IDRIMTZWNkgxOFY0WiIgZmlsbD0iIzUyNjA2OSIvPgo8cGF0aCBkPSJNMTggOEgxNlYxMEgxOFY4WiIgZmlsbD0iIzUyNjA2OSIvPgo8cGF0aCBkPSJNMTggMTJIMTZWMTRIMThWMTJaIiBmaWxsPSIjNTI2MDY5Ii8+CjxwYXRoIGQ9Ik0wIDhWMThINlYxM0g4VjE4SDE0VjhMNyAzTDAgOFpNMTIgMTZIMTBWMTFINFYxNkgyVjlMNyA1LjVMMTIgOVYxNloiIGZpbGw9IiM1MjYwNjkiLz4KPHBhdGggZD0iTTkgMFYxLjk3TDExIDMuNFYySDIwVjE2SDE2VjE4SDIyVjBIOVoiIGZpbGw9IiM1MjYwNjkiLz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };